<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';
import type { Link } from '@/types';

defineProps<{
  title: string;
  links: Link[];
}>();
</script>

<template>
  <ContentContainer>
    <ContentColumn>
      <div class="subhead-secondary title">
        {{ title }}
      </div>
      <div class="links">
        <NuxtLink
          v-for="({ title: itemTitle, url, target, linkTitle }, idx) in links"
          :key="idx"
          :to="url"
          :target="target"
          :title="linkTitle"
          class="link"
        >
          <h5>{{ itemTitle }}</h5>
          <div class="body-small link-caption">
            {{ linkTitle || url }}
          </div>
        </NuxtLink>
      </div>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.title {
  text-transform: uppercase;
  color: var(--colour-mid-grey);
}
.link {
  padding: var(--spacing-ms) 0;
  padding-right: 5rem;
  border-bottom: 0.1rem dotted var(--colour-warm-grey);
  display: block;
  text-decoration: none !important;
  background: url(@/icons/external-link.svg) no-repeat right 2rem center / 1.4rem;

  h5 {
    margin: 0 0 0.5rem;
  }

  .link-caption {
    color: var(--colour-mid-grey);
    transition: color 0.5s ease;
  }

  &:hover {
    .link-caption {
      color: var(--colour-accent);
    }
  }

  @include screen.respond(tablet) {
    background-position: right center;
  }
}
</style>
